export default __webpack_public_path__ + "static/media/mobile.743ed450.jpg";